import {
  AfterViewInit,
  Component,
  input,
  OnDestroy,
  TemplateRef,
  viewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';
import { DomPortalOutlet, TemplatePortal } from '@angular/cdk/portal';

@Component({
  selector: 'abb-loader',
  standalone: true,
  imports: [MatProgressSpinnerModule, MatProgressBarModule, CommonModule],
  template: `
    <ng-template #portal>
      <div
        class="inset-0 fixed bg-abb-gray-02/20 flex justify-center transition-all"
        [ngClass]="{
          'z-[10000] opacity-100': show(),
          'z-0 opacity-0 pointer-events-none flex-0': !show(),
          'items-center': type() === 'spinner'
        }"
      >
        @if (type() === 'spinner') {
        <mat-progress-spinner
          [diameter]="60"
          color="primary"
          mode="indeterminate"
        ></mat-progress-spinner>
        } @else {
        <mat-progress-bar
          [color]="'primary'"
          mode="indeterminate"
          class="flex-1"
        ></mat-progress-bar>
        }
      </div></ng-template
    >
  `,
  styles: ``,
  host: {
    class: 'absolute'
  }
})
export class AbbLoaderComponent implements AfterViewInit, OnDestroy {
  type = input<'spinner' | 'bar'>('spinner');
  show = input(false);
  portal = viewChild<TemplateRef<HTMLDivElement>>('portal');
  templatePortal: TemplatePortal | undefined;
  portalOutlet: DomPortalOutlet | undefined;
  constructor(private _vcr: ViewContainerRef) {}
  ngOnDestroy(): void {
    this.templatePortal?.detach();
    this.portalOutlet?.dispose();
  }
  ngAfterViewInit(): void {
    this.templatePortal = new TemplatePortal(this.portal()!, this._vcr);
    this.portalOutlet = new DomPortalOutlet(document.body);

    this.portalOutlet.attach(this.templatePortal);
  }
}
